// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MobileTwoToneSvg from "@fishx/icons-svg/es/asn/MobileTwoTone";
import FishxIcon from '../components/FishxIcon';

var MobileTwoTone = function MobileTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MobileTwoToneSvg
  }));
};

MobileTwoTone.displayName = 'MobileTwoTone';
export default React.forwardRef(MobileTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MobileTwoTone.js
// module id = 3151
// module chunks = 0